/**
 * Safari 17-compatible stand-in for `URL.parse()`, which only shipped in
 * Safari 18. Returns `null` instead of throwing on a malformed URL.
 */
export const parseUrl = (url: string, base?: string | URL): URL | null => {
  try {
    return new URL(url, base);
  } catch {
    return null;
  }
};
